import { Component, Vue, Watch } from "vue-property-decorator";
import iziToast from "izitoast";
import adtPagination from "@/components/communs/Pagination.vue";
import Spinner from "@/components/Spinner.vue";
import Helpers from "@/helpers/helpers";
import SearchBox from "@/components/SearchBox.vue";
import StatusBadge from "@/components/StatusBadge.vue";

import dayjs from "dayjs";
import {
  DeserializedFileRequest,
  DeserializedFileResponse,
} from "@/models/Reconciliation/reconciliationFile.interface";
import { Acquirer } from "@/models/acquirer.interface";

@Component({
  components: {
    adtPagination,
    Spinner,
    "adt-search-box": SearchBox,
    "status-badge": StatusBadge,
  },
})
export default class FilesList extends Vue {
  private isLoading = false;
  private acquirers: Acquirer[] = [];
  private deserializedFiles: DeserializedFileResponse[] = [];
  private total = 0;
  private parameters: DeserializedFileRequest = {
    originalFileName: "",
    acquirerCode: "",
    keywordSearch: "",
    status: "",
    startDate: "",
    endDate: "",
    sortFieldName: "",
    sortDirection: 0,
    pageSize: 10,
  };

  private range: any = {
    start: dayjs(new Date()).subtract(60, "day").toDate(),
    end: new Date(),
  };
  
  get filesListingOrder() {
    return Helpers.filesListingOrder;
  }

  get spinnerColor() {
    return getComputedStyle(document.documentElement).getPropertyValue("--secondary-color");
  }

  private getStatus() {
    return Helpers.reconciliationFileStatus;
  }

  private created() {
    this.$route.query.currentPage !== undefined && this.$route.query.currentPage > "1"
      ? (this.parameters.currentPage = Number(this.$route.query.currentPage))
      : (this.parameters.currentPage = 1);

    if (this.$route.query.originalFileName !== undefined) {
      this.parameters.originalFileName = this.$route.query.originalFileName as string;
    }

    if (this.$route.query.acquirerCode !== undefined) {
      this.parameters.acquirerCode = this.$route.query.acquirerCode as string;
    }

    if (this.$route.query.keywordSearch !== undefined) {
      this.parameters.keywordSearch = this.$route.query.keywordSearch as string;
    }

    if (this.$route.query.status !== undefined) {
      this.parameters.status = this.$route.query.status as string;
    }

    if (this.$route.query.startDate !== undefined) {
      //@ts-ignore
      this.range.start = dayjs(this.$route.query.startDate).toDate();
      //@ts-ignore
      this.range.end = dayjs(this.$route.query.endDate).toDate();
      this.parameters.startDate = dayjs(this.range.start).format("YYYY-MM-DD");
      this.parameters.endDate = dayjs(this.range.end).format("YYYY-MM-DD");
    } else {
      this.parameters.startDate = dayjs(this.range.start).format("YYYY-MM-DD");
      this.parameters.endDate = dayjs(this.range.end).format("YYYY-MM-DD");
    }    

    this.parameters = {
      ...this.parameters,
      ...this.$route.query,
    };

    this.addParamsToQuerystring(this.parameters);
    this.getAcquirers();
    this.getDeserializedFiles(this.parameters);
  }

  private addParamsToQuerystring(parameters: DeserializedFileRequest) {
    //@ts-ignore
    this.$router.replace({ ...this.$router.currentRoute, query: parameters }).catch(() => {});
  }

  @Helpers.Debounce(800)
  private searchOriginalFileName(value: string) {
    this.parameters.originalFileName = value;
    this.onSearchBox();
  }

  @Helpers.Debounce(800)
  private searchAcquirerCode(value: string) {
    this.parameters.acquirerCode = value;
    this.onSearchBox();
  }

  @Helpers.Debounce(800)
  private searchKeyword(value: string) {
    this.parameters.keywordSearch = value;
    this.onSearchBox();
  }

  @Helpers.Debounce(800)
  private searchFileStatus(value: string) {
    this.parameters.status = value;
    this.onSearchBox();
  }

  private onSearchBox() {
    this.changePage(1);
    this.addParamsToQuerystring(this.parameters);
    this.getDeserializedFiles(this.parameters);
  }

  OnDatePicker(payload: any) {
    if (payload !== null) {
      const payloadStart = dayjs(payload.start).startOf("day").format("YYYY-MM-DD");
      const payloadEnd = dayjs(payload.end).endOf("day").format("YYYY-MM-DD");
      this.parameters.startDate = payloadStart;
      this.parameters.endDate = payloadEnd;
      this.onSearchBox();
    }
  }

  private clearFilter() {
    this.range.start = dayjs(new Date()).subtract(60, "day").toDate();
    this.range.end = new Date();
    this.parameters = {
      keywordSearch: "",
      status: "",
      startDate: dayjs(this.range.start).format("YYYY-MM-DD"),
      endDate: dayjs(this.range.end).format("YYYY-MM-DD"),
      currentPage: 1,
      pageSize: 10,
    };
    this.addParamsToQuerystring(this.parameters);
    this.getDeserializedFiles(this.parameters);
  }

  private changePage(page: number) {
    this.parameters.currentPage = page;
    this.addParamsToQuerystring(this.parameters);
    this.getDeserializedFiles(this.parameters);
  }

  private perPage(e: number) {
    this.parameters.pageSize = e;
    this.getDeserializedFiles(this.parameters);
  }

  private getAcquirers() {
    this.$store
      .dispatch("acquirer/GET_ACQUIRERS", {
        pageSize: 100,
        currentPage: 1,
        filterModeEnum: 2
      })
      .then((result: any) => {
        this.acquirers = result.data.acquirers.filter((acquires: any) => acquires.name == 'Safrapay');
      })
      .catch((err) => {
        iziToast.error({
          title: "Erro:",
          message: err,
          position: "bottomRight",
        });
      });
  }

  private myTest: any = {};

  @Watch('myTest')
  //@ts-ignore
  private selectedFiltersOrder(val: any) {
    if (this.myTest) 
    {
      this.parameters.sortFieldName = this.myTest.fieldName;
      this.parameters.sortDirection = this.myTest.sortOrder;
    }
    else
    {
      this.parameters.sortFieldName = "";
      this.parameters.sortDirection = 0;
    }
    
    //@ts-ignore
    this.onSearchBox();
  }

  private getDeserializedFiles(params: DeserializedFileRequest) {
    this.isLoading = true;
    this.$store
      .dispatch("reconciliation/GET_DESERIALIZED_FILES", {
        originalFileName: params.originalFileName,
        acquirerCode: params.acquirerCode,
        keywordSearch: params.keywordSearch,
        status: params.status,
        startDate: params.startDate,
        endDate: params.endDate,
        currentPage: params.currentPage,
        pageSize: params.pageSize,
        sortFieldName: params.sortFieldName,
        sortDirection: params.sortDirection
      })
      .then((result: any) => {
        this.deserializedFiles = result.data.deserializedfiles;
        this.total = result.data.total;
      })
      .catch((err) => {
        iziToast.error({
          title: "Erro:",
          message: err,
          position: "bottomRight",
        });
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
